import {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
  Button,
  Container,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
} from "@mui/material";
// components
import Page from "src/components/Page";
import axios from "axios";
import {alert} from "src/services/alert";
import {COMP_NAME, IMG_BASE_URL} from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import NavBack from "src/components/common/NavBack";
import MyEditor from "src/components/editor/MyEditor";
import Uploader from "src/components/uploader/Uploader";
import UploaderVideo from "src/components/uploader/UploaderVideo";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";

export default function ArticleDetail() {
  const navigate = useNavigate();
  const {id} = useParams();
  const item = useLocation().state || {};

  const [detail, setDetail] = useState(item.detail);
  const [typeList, setTypeList] = useState([]);
  const [form, setForm] = useState({
    html: item.html || "",
    title: item.title || "",
    subtitle: item.subtitle || "",
    cover: item.cover || null,
    src: item.src || null,
    path: item.path || "",
    beginTime: null,
    endTime: null,
    typeName: item.typeName || "",
    type: item.type || "",
    categoryId: item.categoryId ||"",
    isShow: item.isShow !== undefined ? (item.isShow ? 1 : 0) : 1,
  });


  useEffect(() => {
    axios
      .get("/article/category/all")
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          setTypeList(data);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
      });
    if (id) {
        form.title = item.title
        form.typeName = item.categoryId === 1 ? '短视频' : item.categoryId === 2 ? '商学院' : item.categoryId === 3 ? '在线直播' : ''
        form.type = item.categoryId === 1 ? '短视频' : item.categoryId === 2 ? '商学院' : item.categoryId === 3 ? '在线直播' : ''
        form.src = item.src
        form.beginTime = null
        form.endTime = null
        form.detail = item.detail
        setForm({
          ...form,
          form,
        })
    }
  }, []);
  // 判断是否显示视频上传组件
  const shouldShowVideoUploader = () => {
    // 这里根据您的业务逻辑来判断
    return form.categoryId == '1'||form.categoryId == '2';
  };

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  // 通过名称获取ID的函数
  function getIdByName(name) {
    const item = typeList.find(item => item.name === name);
    return item ? item.id : null;
  }

  function checkTime(name) {
    const today = new Date(name);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    // const hours = today.getHours();
    // const minutes = today.getMinutes();
    // const seconds = today.getSeconds();
    return year + '-' + month + '-' + day
  }

  function handleSubmit() {
    form.categoryId = form.categoryId?form.categoryId:''
    form.type = form.categoryId
    const formData = {
      ...form,
      detail,
    };

    if (id) {
      formData.id = id;
    }
    // console.log('提交的数据:', formData); // 调试用
    axios
      .post(id ? "/article/edit" : "/article/add", formData)
      .then((res) => {
        const {code, msg, data} = res.data;
        if (code === 1) {
          navigate(-1, {replace: true});
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加文章出错: ", err);
      });
  }

  const handleChange = (event) => {
    setForm({
      ...form,
      categoryId: event.target.value,
    });
  };

  function handleFilterChange(ki, val) {
    setForm({
      ...form,
      page: 0,
      [ki]: val,
    });
  }

  return (
    <Page title={`${id ? "编辑" : "添加"}文章 | ${COMP_NAME}`}>
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title={`${id ? "编辑" : "添加"}文章`}/>
        </Stack>

        <Paper variant="outlined" sx={{py: 1, pr: 3}}>
          <FormItem title="标题" required>
            <TextField fullWidth placeholder="请输入标题" autoComplete="off" id="title" value={form.title} size="small"
                       onChange={(e) => handleIptChange("title", e.target.value)}/>
          </FormItem>
          <FormItem title="类别" required>
            <FormControl size="small" sx={{minWidth: 250}}>
              <InputLabel>请选择类别</InputLabel>
              <Select
                label="请选择类别"
                value={form.categoryId}
                onChange={(e) => handleChange(e)}
              >
                <MenuItem value="">
                  <em>全部</em>
                </MenuItem>
                {typeList.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormItem>
          {shouldShowVideoUploader() && (
            <FormItem title="视频" required>
              <UploaderVideo videos={form.path} onUploaded={(v) => handleIptChange("src", v)}/>
              {/* 视频预览 */}
              {form.src && (
                <div style={{display: 'block', marginLeft: '20px'}}>
                  <video key={form.src} controls
                         style={{
                           maxWidth: '300px',
                           maxHeight: '200px',
                           border: '1px solid #ddd',
                           borderRadius: '4px',
                         }}>
                    <source src={form.src} type="video/mp4"/>
                    您的浏览器不支持视频播放
                  </video>
                </div>
              )}
              {/* 视频预览 */}
            </FormItem>
          )}
          <FormItem title="封面">
            {/* multiple  可以上传多张图片 */}
            {/* <Uploader multiple images={form.cover} onUploaded={(v) => handleIptChange("cover", v)} /> */}
            <Uploader images={form.cover} onUploaded={(v) => handleIptChange("cover", v)}/>
          </FormItem>

          <FormItem title="状态" required>
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
              <FormControlLabel value={0} control={<Radio/>} label="隐藏"
                                onChange={(e) => handleIptChange("isShow", e.target.value)}/>
              <FormControlLabel value={1} control={<Radio/>} label="显示"
                                onChange={(e) => handleIptChange("isShow", e.target.value)}/>
            </RadioGroup>
          </FormItem>
          <FormItem title="定时">
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
              <DateTimePicker
                views={["year", "day", "hours", "minutes", "seconds"]}
                timeSteps={{
                  minutes: 1,
                  seconds: 1,
                }}
                ampm={false}
                label="起始时间"
                size="small"
                value={form.beginTime ? moment(form.beginTime) : null}
                onChange={(newValue) => {
                  // console.log(newValue);
                  const d = moment(new Date(newValue)).format("YYYY-MM-DD hh:mm:ss");
                  handleFilterChange("beginTime", new Date(newValue))
                }}
              />
            </LocalizationProvider>
            <p style={{lineHeight: '56px', margin: '0 12px'}}>至</p>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
              <DateTimePicker
                views={["year", "day", "hours", "minutes", "seconds"]}
                timeSteps={{
                  minutes: 1,
                  seconds: 1,
                }}
                ampm={false}
                label="起始时间"
                size="small"
                value={form.endTime ? moment(form.endTime) : null}
                onChange={(newValue) => {
                  // console.log(newValue);
                  const d = moment(new Date(newValue)).format("YYYY-MM-DD hh:mm:ss");
                  handleFilterChange("endTime", new Date(newValue))
                }}
              />
            </LocalizationProvider>
          </FormItem>


          {/* <FormItem title="摘要">
            <TextField fullWidth placeholder="请输入摘要，不填写可能选取正文前20个文字" autoComplete="off" id="subtitle" value={form.subtitle} size="small" onChange={(e) => handleIptChange("subtitle", e.target.value)} />
          </FormItem> */}

          <FormItem title="内容" required>
            <Paper variant="outlined" sx={{paddingX: 2, paddingY: 1, flex: 1, minHeight: 220}}>
              <MyEditor
                html={form.detail}
                onChange={(val) => {
                  setDetail(val);
                }}
              />
            </Paper>
          </FormItem>

          <FormItem>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              确认{id ? "保存" : "添加"}
            </Button>
          </FormItem>
        </Paper>
      </Container>
    </Page>
  );
}
